// Copyright (c) Microsoft. All rights reserved.

import { makeStyles, mergeClasses, shorthands, tokens } from '@fluentui/react-components';
import { Alert } from '@fluentui/react-components/unstable';
import React from 'react';
import { useAppSelector } from '../../redux/app/hooks';
import { RootState } from '../../redux/app/store';
// import { removeAlert } from '../../redux/features/app/appSlice';
// import { Dismiss16 } from './BundledIcons';
import { SharedStyles } from '../../styles';

const useClasses = makeStyles({
  alert: {
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground1,
    lineHeight: tokens.lineHeightBase200,
    maxWidth: '600px',
    ...shorthands.margin('12px', 'auto', '12px', 'auto'),
    justifyContent: 'space-between',
    ...SharedStyles.alert,

    '&span': {
      fontSize: '20px',
    },
    '&.info': {
      ...SharedStyles.info,
    },
    '&.error': {
      ...SharedStyles.error,
    },
    '&.warning': {
      ...SharedStyles.warning,
    },
    '&.success': {
      ...SharedStyles.success,
    },
  },
  actionItems: {
    display: 'flex',
    flexDirection: 'row',
    ...shorthands.gap(tokens.spacingHorizontalMNudge),
  },
  button: {
    alignSelf: 'center',
  },
});

export const Alerts: React.FC = () => {
  const classes = useClasses();
  //   const dispatch = useAppDispatch();
  const { alerts } = useAppSelector((state: RootState) => state.app);

  return (
    <div>
      {alerts.map(({ type, message, onRetry }, index) => {
        return (
          <Alert
            // intent={type}
            action={{
              children: (
                <div className={classes.actionItems}>
                  {onRetry && <div onClick={onRetry}>다시하기</div>}
                  {/* <Dismiss16
                                        aria-label="dismiss message"
                                        onClick={() => {
                                            dispatch(removeAlert(index));
                                        }}
                                        color="black"
                                        className={classes.button}
                                    /> */}
                </div>
              ),
            }}
            key={`${index}-${type}`}
            className={mergeClasses(classes.alert, type)}
          >
            {message.slice(0, 200) + (message.length > 200 ? '...' : '')}
          </Alert>
        );
      })}
    </div>
  );
};
